import * as React from "react";
import { Fragment, FunctionComponent } from "react";

//MUI
import Dialog from "@mui/material/Dialog";

//Custom Components
import DraggableDialog from "@/ui/Dialog/DraggableDialog";

//Types
import { IDraggableDialog } from "@/@types/ui/Dialog";

const DynamicDialog: FunctionComponent<IDraggableDialog> = (props) => {
  const { fixedHeight, children, onClose, disableFullscreen, forceFullscreen, disableDrag } =
    props;

  const maxWidth = props.maxWidth === undefined ? "lg" : props.maxWidth;

  return (
    <Fragment>
      {forceFullscreen ? (
        <Dialog open={true} fullScreen={true}>
          {children}
        </Dialog>
      ) : (
        <>
          <DraggableDialog
            sx={{
              display: {
                xs: disableFullscreen ? "block" : "none",
                md: "block",
              },
            }}
            disableDrag={disableDrag}
            open={true}
            fullScreen={false}
            fixedHeight={fixedHeight}
            maxWidth={maxWidth}
            onClose={onClose}
          >
            {children}
          </DraggableDialog>
          <Dialog
            sx={{
              display: { xs: disableFullscreen ? "none" : "block", md: "none" },
            }}
            open={true}
            fullScreen={true}
          >
            {children}
          </Dialog>
        </>
      )}
    </Fragment>
  );
};

export default DynamicDialog;
